import AlgoliaAutocomplete from "./algolia-autocomplete";
import MBTAGoCTABanner from "./mbta-go-cta-banner";
import PageVisibility from "./page-visibility";
import ScrollIntoView from "./scroll-into-view";
import TripPlannerForm from "./trip-planner-form";
import TripPlannerMap from "./trip-planner-map";
import TripPlannerDatePicker from "../../js/trip-planner/datepicker";

/**
 * Configurations for usage with [Phoenix LiveView's
 * phx-hook](https://hexdocs.pm/phoenix_live_view/js-interop.html#client-hooks-via-phx-hook)
 *
 * The functionality written for the various life-cycle callbacks should be
 * defined in other modules which have their own test coverage, as Phoenix hooks
 * themselves are not tested via Jest unit tests.
 */
const Hooks = {
  AlgoliaAutocomplete,
  MBTAGoCTABanner,
  PageVisibility,
  ScrollIntoView,
  TripPlannerDatePicker,
  TripPlannerForm,
  TripPlannerMap
};

export default Hooks;
